"use client";
import {
  DateInputField
} from "./chunk-X6WGSOI4.mjs";
import {
  DateInputGroup
} from "./chunk-YVBCSFY6.mjs";
import {
  useTimeInput
} from "./chunk-DXQ6KM2N.mjs";

// src/time-input.tsx
import { forwardRef } from "@nextui-org/system";
import { jsx } from "react/jsx-runtime";
var TimeInput = forwardRef(function TimeInput2(props, ref) {
  const { state, slots, classNames, getBaseGroupProps, getInputProps, getFieldProps } = useTimeInput({
    ...props,
    ref
  });
  return /* @__PURE__ */ jsx(DateInputGroup, { ...getBaseGroupProps(), children: /* @__PURE__ */ jsx(
    DateInputField,
    {
      classNames,
      inputProps: getInputProps(),
      slots,
      state,
      ...getFieldProps()
    }
  ) });
});
var time_input_default = TimeInput;

export {
  time_input_default
};
